import {Component} from '@angular/core';
import {NzContentComponent, NzFooterComponent, NzLayoutModule} from "ng-zorro-antd/layout";
import {NzBreadCrumbModule} from "ng-zorro-antd/breadcrumb";
import {RouterLink, RouterOutlet, Router} from "@angular/router";
import {NzSliderModule} from "ng-zorro-antd/slider";
import {NzPageHeaderModule} from "ng-zorro-antd/page-header";
import {NzMenuItemComponent, NzMenuModule} from "ng-zorro-antd/menu";
import {NzIconDirective} from "ng-zorro-antd/icon";
import {BaseManagementService} from "./base.management.service";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-home',
  templateUrl: './base.management.component.html',
  standalone: true,
  imports: [
    NzLayoutModule,
    NzSliderModule,
    NzPageHeaderModule,
    NzContentComponent,
    NzBreadCrumbModule,
    RouterOutlet,
    NzFooterComponent,
    NzMenuModule,
    NzMenuItemComponent,
    RouterLink,
    NzIconDirective,
    NgIf
  ],
  styleUrl: './base.management.component.less',
  providers: [
    {provide: BaseManagementService, useClass: BaseManagementService},
  ]
})
export class BaseManagementComponent {
  isCollapsed = false;

  constructor(private router: Router) {}

  goBackToSystemSelection(): void {
    this.router.navigate(['/']).then(() => {}).catch(err => console.error(err));
  }
}
